import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-bg-items-black relative z-0 container flex py-[64px] lg:py-[80px]',
    rowText:
      'flex w-full flex-wrap items-center gap-[32px] lg:mx-auto lg:max-w-320 lg:flex-nowrap lg:gap-[96px]',
    main: 'flex w-full flex-col gap-[16px] lg:max-w-[320px] xl:max-w-[480px] xl:gap-[24px]',
    mainIcon: 'pb-[8px]',
    mainTitle: 'text-xl leading-[1.2] font-semibold lg:text-2xl',
    mainDescription: 'lg:text-m text-xs leading-[1.5] font-light',
    link: 'font-regular flex items-center gap-[2px] text-xs leading-[1.4] lg:text-base',
    linkIcon: 'size-[16px] rotate-270',
    pages: 'w-full',
    itemsTitle: 'mb-5 text-2xl leading-[1.2] lg:mb-8 lg:text-5xl',
    itemsList: '',
    image: 'rounded-full',
    item: 'group relative flex cursor-pointer items-center gap-5 rounded-tr-[1000px] rounded-br-[1000px] not-first:-mt-3 before:absolute before:top-4 before:right-0 before:bottom-4 before:left-20 before:rounded-tr-[1000px] before:rounded-br-[1000px] before:opacity-0 before:duration-300 hover:before:opacity-100 lg:gap-8 lg:not-first:-mt-6 hover:lg:before:bg-white hover:lg:before:opacity-100',
    itemImage:
      'z-1 max-w-30 min-w-30 rounded-full border-2 border-white lg:max-w-50 lg:min-w-50',
    info: 'relative z-1 grid w-full gap-2 lg:pr-15',
    title: 'text-base leading-[1.4] font-extrabold lg:text-xl',
    subtitle:
      'font-regular flex items-center justify-between gap-[8px] text-xs leading-[1.4] lg:text-base',
    arrow:
      'absolute top-1/2 right-8 hidden -translate-y-1/2 rotate-270 opacity-0 lg:block lg:group-hover:opacity-100',
    arrowMobile: 'block size-[24px] min-w-[24px] rotate-270 lg:hidden'
  },
  variants: {
    activeItem: {
      true: {
        item: 'lg:before:bg-white lg:before:opacity-100'
      }
    },
    variant: {
      primary: {},
      secondary: {}
    }
  },
  compoundVariants: [
    {
      variant: 'primary',
      activeItem: true,
      className: {
        item: 'lg:before:bg-white lg:hover:before:bg-white'
      }
    },
    {
      variant: 'secondary',
      activeItem: true,
      className: {
        item: 'lg:before:bg-white lg:hover:before:bg-white'
      }
    }
  ],
  defaultVariants: {
    variant: 'primary'
  }
});
